import { DataGrid, GridToolbar } from '@mui/x-data-grid';

const ViewVendorBankDetails = ({ data }) => {
    const Columns = [
        {
            headerName: "Vendor Email",
            field: "email",
            minWidth: 150,
        },
        {
            headerName: "Vendor Mobile",
            field: "mobileNo",
            minWidth: 150,
        },
        {
            headerName: "Bank Name",
            field: "bankName",
            minWidth: 150,
        },
        {
            headerName: "Branch Name",
            field: "branchName",
            minWidth: 150,
        },
        {
            headerName: "Account number",
            field: "accountNumber",
            minWidth: 150,
        },
        {
            headerName: "IFSC Code",
            field: "ifscCode",
            minWidth: 150,
        }
    ];

    return (
        <>
            <DataGrid
                rows={data || []}
                columns={Columns}
                slots={{
                    toolbar: GridToolbar,
                }}
            />
        </>
    );
};

export default ViewVendorBankDetails;